<template>
  <v-container>
    <!-- <v-row>
      <v-col cols="auto" class="px-0">
        <v-btn
          @click="closeDepartmentDetails"
          :style="`opacity:${isOpenDetails ? '1' : '0'}`"
          icon
          color="primary"
          fab
          small
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="d-flex align-center">
        <p class="text-h6 mb-0" v-if="title">{{ title || "Directorio" }}</p>
      </v-col>
    </v-row> -->

    <v-container fluid v-if="!isOpenDetails">
      <!-- <v-row class="justify-end align-center" style="min-height:68px">
        <v-col cols="auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row> -->

      <v-card class="shadow-1 mt-5 mt-md-10">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="directoryList"
          item-key="id"
          :loading="isLoading"
          :options.sync="options"
          no-data-text="No hay registros que mostrar"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.associated_extensions`]="{ item }">
            <v-row>
              <v-col
                cols="auto"
                class="px-1"
                v-for="extension in item.associated_extensions"
                :key="extension"
              >
                <v-chip>{{ extension }}</v-chip>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="openDepartamentDetails(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <department-details
      v-else
      :department="departmentSelected"
    ></department-details>
  </v-container>
</template>

<script>
import DepartmentDetails from "../../../components/Directory/DepartmentDetails.vue";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  name: "DirectoryList",

  components: { DepartmentDetails },

  data() {
    return {
      isLoading: false,
      isOpenDetails: true,
      search: "",
      // For pagination
      //   totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      title: "Directorio",
      directoryList: [],
      departmentSelected: {},
      headers: [
        {
          text: "Departamento",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Extensiones asociadas",
          value: "associated_extensions",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
      ],
    };
  },

  // watch: {
  //   options: {
  //     handler() {
  //       this.getDirectory();
  //     },
  //     deep: true,
  //   },
  // },

  // created() {
  //   this.getDirectory();
  // },

  methods: {
    async getDirectory() {
      const { page } = this.options || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/admin/directory", {
          params: { page, itemPerPage },
        });
        // console.log("data", data);
        // const { data } = await new Promise((res, rej) => {
        //   setTimeout(
        //     () =>
        //       res({
        //         data: [
        //           {
        //             name: "Test Departamento",
        //             associated_extensions: [789, 456, 778, 990],
        //           },
        //         ],
        //       }),
        //     2000
        //   );
        // });
        this.directoryList = data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },
    openDepartamentDetails(item) {
      this.departmentSelected = item;
      this.title = item.name;
      this.isOpenDetails = true;
    },
    closeDepartmentDetails() {
      this.title = null;
      this.isOpenDetails = false;
    },
  },
};
</script>

<style></style>
